<template>
  <div>
    <v-card>
      <!-- <v-card-title>
        <v-text-field v-model="search" label="Schnellsuche" single-line></v-text-field>
      </v-card-title> -->
      <v-data-table
        :headers="computedHeaders"
        :items="guestcards"
        :hide-default-header="$vuetify.breakpoint.xsOnly"
        item-key="id"
        class="elevation-1"
        :search="search"
        hide-sort
      >
        <!-- <template v-slot:expanded-item="t">
          <td :colspan="headers.length + 1" class="detailInfo">
            <TicketDetailInfo v-bind:ticket="t.item" />
          </td>
        </template> -->
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
	name: 'guestcardTable',
	props: ['guestcards'],
	data() {
		return {
			search: '',
			expanded: [],
			expandedTicketId: '',
			headers: [
				{ text: 'Guest card name', value: 'guestcard' },
				{ text: 'Number of issued guest cards', value: 'guestcardissuedamount' },
				{ text: 'Number of activated guest cards', value: 'activatedguestcards' },
				{ text: 'Guest card offer (Value Added)', value: 'guestcardoffer' },
				{ text: 'Type of Guest Card Offer', value: 'typeofguestcardoffer' },
				{ text: 'Service Provider', value: 'serviceprovider' },
				{ text: 'Number of activated value-added services', value: 'activatedservicesamount' },
				{ text: 'Number of consumed value-added services', value: 'consumedservicesamount' },
				{ text: 'Product name', value: 'productname' },
				{ text: 'Product SKU', value: 'productsku' },
			],
		}
	},
	computed: {
		computedHeaders() {
			return this.headers.filter((h) => !h.hide)
		},
	},
}
</script>

<style scoped>
</style>
